import _ from 'lodash';
import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {types, endpoints} from 'main/tools';
import {calendarDate} from 'shared/tools';

class PayPeriodEmployeesState {
  store = new DomainStore();
  match;

  employees;
  notes;
  payPeriod;
  payNumber;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({match}) {
    this.match = match;
  }

  async load() {
    const id = _.get(this.match.params, 'period_id');

    await this.store._compose([
      endpoints.PAY_PERIOD.WITH_EMPLOYEES.with(id)
    ]);

    this.payPeriod = this.store._getSingle(types.PAY_PERIOD, {id});
  }

  get calendarStartDate() {
    return calendarDate(this.payPeriod.periodStartDate);
  }

  get calendarEndDate() {
    return calendarDate(this.payPeriod.periodEndDate);
  }

  get calendarCutoffWarningDate() {
    return calendarDate(this.payPeriod.cutoffWarningDate);
  }

  get calendarPayDate() {
    return calendarDate(this.payPeriod.payDate);
  }
}

export default PayPeriodEmployeesState;
